import { render, staticRenderFns } from "./CarrierImage.vue?vue&type=template&id=95d042dc&"
import script from "./CarrierImage.vue?vue&type=script&lang=js&"
export * from "./CarrierImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports